import { logError } from 'client/javascript/util/logger';
import { geoData } from 'client/javascript/geo';
import { setupCardProductPromoTagsModule } from 'client/javascript/pages/shared/sections/card_product';
import {
  isUserCountryInWhitelistedCountriesList,
  showModule,
  GEO_MODULE_SELECTOR
} from 'client/javascript/util/geolocation_based_module_rendering/helpers';

export const HERO_TAKEOVER_CONTAINER = 'homepage-promo';
const TRANSPARENT_NAV_CLASS = 'page-nav--transparent';
const TRANSPARENT_NAV_CONTAINER_CLASS = 'page-nav-container--transparent';
export const OVERLAYED_HOME_CLASS = 'home-container--overlayed';
const BURGER_WHITE_CLASS = 'burger-color--white';

export async function setupHeroTakeoverModule() {
  try {
    const takeoverModule = document.querySelector(`.${HERO_TAKEOVER_CONTAINER}${GEO_MODULE_SELECTOR}`);
    if (!takeoverModule) {
      return null;
    }
    const { countryCode } = await geoData;
    const { conditionsToShow } = takeoverModule.dataset;
    const shouldBeDisplayed = isUserCountryInWhitelistedCountriesList(countryCode, conditionsToShow);
    if (shouldBeDisplayed) {
      showModule(takeoverModule);
      setupCardProductPromoTagsModule();
    } else {
      const transparentNav = document.querySelector(`.${TRANSPARENT_NAV_CLASS}`);
      const transparentNavContainer = document.querySelector(`.${TRANSPARENT_NAV_CONTAINER_CLASS}`);
      const overlayedHome = document.querySelector(`.${OVERLAYED_HOME_CLASS}`);
      const mobileMenuBurger = document.querySelector(`.${BURGER_WHITE_CLASS}`);
      if (transparentNav) {
        transparentNav.classList.remove(TRANSPARENT_NAV_CLASS);
      }
      if (transparentNavContainer) {
        transparentNavContainer.classList.remove(TRANSPARENT_NAV_CONTAINER_CLASS);
      }
      if (overlayedHome) {
        overlayedHome.classList.remove(OVERLAYED_HOME_CLASS);
      }
      if (mobileMenuBurger) {
        mobileMenuBurger.classList.remove(BURGER_WHITE_CLASS);
      }
    }
  } catch (error) {
    logError(`Homepage setupHeroTakeoverModule failed: ${error.message}`, error);
  }
}
